module.exports = __webpack_public_path__ + "img/ic-bni.845ee51f.png";